import React, { useEffect, useState } from 'react';
import './App.css';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
import Jobs from "./Jobs";
import JobClassificationWidget from './JobClassificationWidget';
import AllJobsWidget from './AllJobsWidget';

export interface ActiveJobs {
  pk: string;
  sk: string;
  activeJobList: Array<Job>
  updatedAt: string
}

export interface Job {
  Reference: string;
  Title: string;
  ShortDescription: string;
  AdDetail: string;
  Consultant: string;
  ContactNumber: string;
  ContactEmail: string;
  CompanyName: string;
  Location: string;
  JobType: string;
  Classification: string;
  Position: string;
  LinkOutUrl: string;
  ApplicationEmail: string;
  SalaryType: string;
  SalaryMin: string;
  SalaryMax: string;
  SalaryCurrency: string;
  ResidentOnly: string;
  timestamp: string;
}

function App() {

  const [jobs, setJobs] = useState<Array<Job>>()
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    setLoading(true)
    fetch('api/jobs')
    .then((response: any) => response.json())
    .then((data: ActiveJobs) => {
        if(data) {
            let list = data.activeJobList.sort((a,b) => (parseInt(a.timestamp) > parseInt(b.timestamp)) ? -1 : 1)
            setJobs(list)
        }
        setLoading(false)
    })
    .catch((error: any) => {
        console.log("Error: fetching jobs", error)
        setLoading(false)
    })
}, [])

  return (
    <div style={{overflowX: "hidden"}}>
      
      <Router>
        <Switch>
          <Route path="/jobs/classification/:classification">
            <JobClassificationWidget jobs={jobs} loading={loading} />
          </Route>
          <Route path="/jobs/all">
            <AllJobsWidget jobs={jobs} loading={loading} />
          </Route>
          <Route path="/jobs">
            <Jobs jobs={jobs} loading={loading} />
          </Route>
          <Route exact path ="/">
            <Redirect to="/jobs" />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
